import React from "react";
import { useNavigate } from "react-router-dom";
import { Lock, ArrowLeft, Star } from "lucide-react";
import { useAuth } from "@/auth/AuthContext";
import { TIER_LABELS } from "@/lib/tiers";

// Individual Plus access gate. Renders the module only for Plus-entitled accounts
// (Individual Plus, Business, Brand Partner, Admin). Everyone else (Individual Free)
// sees an upgrade prompt. Respects a Features Control toggle-off (admins always pass).
// Visibility/access gating only — the gated module itself is unchanged.
function ProUnavailable({ toggledOff }) {
  const navigate = useNavigate();
  return (
    <div className="max-w-xl mx-auto text-center py-20 px-6" data-testid="pro-unavailable">
      <div className="w-14 h-14 rounded-2xl bg-brand/10 flex items-center justify-center mx-auto mb-5">
        {toggledOff ? <Lock className="w-6 h-6 text-brand" /> : <Star className="w-6 h-6 text-brand" />}
      </div>
      <h1 className="font-serif text-3xl text-ink mb-2">
        {toggledOff ? "Turned off for your account" : `Upgrade to ${TIER_LABELS.plus}`}
      </h1>
      <p className="text-muted-foreground mb-7">
        {toggledOff
          ? "This module is currently turned off for your account. Please contact your administrator."
          : `This feature is available on the ${TIER_LABELS.plus}, ${TIER_LABELS.business} and ${TIER_LABELS.brand_partner} plans. Upgrade to unlock it.`}
      </p>
      <div className="flex items-center justify-center gap-3">
        <button data-testid="pro-unavailable-back" onClick={() => navigate("/")}
          className="inline-flex items-center gap-2 rounded-full border border-line px-5 py-2.5 text-sm text-ink hover:border-brand transition-colors">
          <ArrowLeft className="w-4 h-4" />Back home
        </button>
        {!toggledOff && (
          <button data-testid="pro-unavailable-upgrade" onClick={() => navigate("/membership")}
            className="inline-flex items-center gap-2 rounded-full bg-brand text-white px-5 py-2.5 text-sm hover:opacity-90 transition-opacity">
            See plans
          </button>
        )}
      </div>
    </div>
  );
}

export default function ProGate({ featureKey, children }) {
  const { isPro, isAdmin, features } = useAuth();
  if (!isPro) return <ProUnavailable />;
  if (!isAdmin && featureKey && features && features[featureKey] === false) {
    return <ProUnavailable toggledOff />;
  }
  return children;
}
